module.exports = __webpack_public_path__ + "img/20200312.095086f7.png";